import { WebUser } from 'types/User';
import {webUserHasSelfLink} from 'utils/webUser';

export const getGAUserType = (webUser: WebUser): string =>
  webUserHasSelfLink(webUser) ? 'Tablette' : 'Site Famille';
